import { Menu, MenuProps } from '@mui/material';
import './BaseMenu.module.scss';

type BaseMenuProps = MenuProps & {};

const BaseDropdown = (props: BaseMenuProps) => {
  const { ...restProps } = props;

  return (
    <Menu
     anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      {...restProps}
    ></Menu>
  );
};

export default BaseDropdown;
